import { render, staticRenderFns } from "./HomeBaseListSec.vue?vue&type=template&id=5aa384e8&"
import script from "./HomeBaseListSec.vue?vue&type=script&lang=js&"
export * from "./HomeBaseListSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports